import Vue from 'vue'

// export const baseApiUrl = 'http://localhost/routesys'
export const baseApiUrl = 'http://routesys.effistecnologia.com'


export function showError(e) {
    if(e && e.response && e.response.data) {
        Vue.toasted.global.defaultError({ message : e.response.data })
    } else if(typeof e === 'string') {
        Vue.toasted.global.defaultError({ message : e })
    } else {
        Vue.toasted.global.defaultError()
    }
}

export default { showError }